import { Button, ButtonColor } from "@swivl-mono/ui";
import { PiWarning } from "react-icons/pi";

import Logo from "../../Views/Login/Assets/SwivlLogo.png";

const ErrorView = () => {
  return (
    <div className="flex size-full flex-col items-center justify-center gap-8">
      <img src={Logo} alt="Swivl Logo" className="max-w-48 object-cover" />
      <div className="flex flex-col items-center gap-1">
        <h1 className="font-bold tracking-wide text-gray-400">404</h1>
        <span className="text-xl font-bold text-black">An error has occurred</span>
        <PiWarning className="size-10 text-grey-800" />
      </div>
      <div className="mb-4">
        <Button color={ButtonColor.ORANGE}>
          <a href="mailto:support@tryswivl.com?subject=swivl 404 error" style={{ color: "white" }}>
            Contact Support
          </a>
        </Button>
      </div>
    </div>
  );
};

export default ErrorView;
